import { render, staticRenderFns } from "./HeaderTeamRequestStatus.vue?vue&type=template&id=2c7e1081&scoped=true"
import script from "./headerTeamRequestStatus.ts?vue&type=script&lang=ts&external"
export * from "./headerTeamRequestStatus.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7e1081",
  null
  
)

export default component.exports